import type { Bucket, ListOption, SidebarPayload } from "@/types";

export function buildListOptions(sidebar: SidebarPayload | undefined): ListOption[] {
  if (!sidebar) return [];
  return [sidebar.inbox, sidebar.later]
    .filter((bucket): bucket is Bucket => bucket !== null)
    .map(({ id, name, kind }) => ({ id, name, kind }));
}
